import { useEffect, useState } from "react";
import { startCountdown, decideClaim, deleteClaim } from "../../action";
import { useDispatch, useSelector } from "react-redux";

export const UnderAssessmentRow = ({
  address,
  description,
  index,
  claimantId,
  claimantName,
  insurer,
  status,
  assessmentStart,
  assessmentTimerEnds,
  assessmentStartDate,
  timestamps,
}) => {
  const [leftDays, setLeftDays] = useState(0);
  const [progress, setProgress] = useState(0);
  const [open, setOpen] = useState(false);

  const keys = Object.keys(timestamps).sort(
    (a, b) => new Date(timestamps[a]) - new Date(timestamps[b])
  );
  const results = keys.map((key) => {
    const currentDate = new Date(timestamps[key]);
    const today = new Date();

    // Calculate the difference in time and convert to days
    const diffTime = Math.abs(today - currentDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return {
      timestamp: key,
      daysAgo: diffDays,
    };
  });
  const dispatch = useDispatch();
  const [assessmentStartFinalDate, setAssessmentStartFinalDate] = useState("");
  useEffect(() => {
    if (assessmentStartDate) {
      const dateObj = new Date(assessmentStartDate);
      const today = new Date();
      const origianlDate = new Date(dateObj.toDateString());
      const todayDateOnly = new Date(today.toDateString());
      const diffTime = todayDateOnly - origianlDate;
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      setAssessmentStartFinalDate(diffDays);
    }
  }, [assessmentStartDate]);

  const state = useSelector((state) => state.reducer);
  const jwtToken = localStorage.getItem("jwtToken");

  useEffect(() => {
    // Get left time
    const endTime = new Date(assessmentTimerEnds);
    const startTime = new Date(assessmentStart);
    const totalDays =
      (endTime.getTime() - startTime.getTime()) / (1000 * 60 * 60 * 24);
    const currentDate = new Date();
    const differenceInMs = endTime.getTime() - currentDate.getTime();
    const daysLeft = Math.ceil(differenceInMs / (1000 * 60 * 60 * 24));
    setLeftDays(daysLeft);

    // Get proress value
    setProgress(Math.min(((totalDays - daysLeft) / totalDays) * 100, 100));
  }, [assessmentStart, assessmentTimerEnds]);

  return (
    <tr key={index} className="border-t">
      <td className="px-6 py-4 text-center">{address}</td>
      <td className="px-6 py-4 text-center">{claimantName}</td>
      <td className="px-6 py-4 text-center">{insurer}</td>
      <td className="px-6 py-4 text-center">{description}</td>
      <td className="px-6 py-4 text-center relative">
        <div
          className="bg-blue-50 hover:bg-blue-100 px-2 py-1 border border-blue-100 rounded-2xl w-max mx-auto text-blue-700 cursor-pointer"
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
        >
          {status}
          {open && (
            <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 bg-white shadow-lg rounded-xl p-4 w-56 z-10 text-sm">
              {results?.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <strong>
                    {item.timestamp === "createdAt"
                      ? "Authorized"
                      : item.timestamp === "assessmentStart"
                      ? "Under Assessment"
                      : item.timestamp === "appealStart"
                      ? "Appeal in Progress"
                      : item.timestamp === "afcaWonDate"
                      ? "Scope of Works"
                      : item.timestamp === "cashSettlementDate"
                      ? "Cash Settlement"
                      : item.timestamp === "eggHatchedDate"
                      ? "Egg Hatched"
                      : item.timestamp === "afcaAppealMadeDate"
                      ? "AFCA Appeal"
                      : item.timestamp === "afcaAppealMadeDate"
                      ? "AFCA Appeal"
                      : item.timestamp === "declinedDate"
                      ? "AFCA Claim Denied"
                      : ""}
                  </strong>
                  : {item.daysAgo} day{item.daysAgo !== 1 && "s"}
                </div>
              ))}
            </div>
          )}
        </div>
      </td>
      <td className="px-6 py-4 text-center">
        <div className="flex flex-col gap-y-1">
          <div className="flex justify-between text-xs">
            <p>Countdown timer</p>
            <p>{`${leftDays} days left`}</p>
          </div>
          <div className="bg-gray-200 dark:bg-gray-200 rounded-full w-full h-2.5">
            <div
              className="bg-blue-500 rounded-full h-2.5"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          <div className="flex justify-between text-xs">
            <p>Start</p>
            <p>10 business days</p>
          </div>
        </div>
      </td>
      <td className="px-6 py-4 text-center">
        {state.role === 0 ? (
          <div className="flex flex-col space-y-2 w-full">
            <button
              onClick={() =>
                dispatch(decideClaim(claimantId, "approved", jwtToken))
              }
              className="relative px-5 py-2  tracking-wide text-white  rounded-lg bg-gradient-to-br from-green-400 to-green-600 shadow-lg transition duration-300 ease-in-out transform hover:scale-105 hover:from-green-500 hover:to-green-700 hover:shadow-2xl active:scale-95 animate-pulse-glow w-full"
            >
              <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
              <span className="relative z-10">Approved</span>
            </button>

            <div className="flex space-x-2 w-full">
              <button
                onClick={() =>
                  dispatch(decideClaim(claimantId, "denied", jwtToken))
                }
                className="relative px-5 py-2  tracking-wide text-white  rounded-lg bg-gradient-to-br from-red-400 to-red-600 shadow-lg transition duration-300 ease-in-out transform hover:scale-105 hover:from-red-500 hover:to-red-700 hover:shadow-2xl active:scale-95 animate-pulse-glow w-full"
              >
                <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
                <span className="relative z-10">Denied</span>
              </button>

              <button
                onClick={() =>
                  dispatch(startCountdown(claimantId, "undo", jwtToken))
                }
                className="relative px-5 py-2  tracking-wide text-white  rounded-lg bg-gradient-to-br from-orange-400 to-orange-600 shadow-lg transition duration-300 ease-in-out transform hover:scale-105 hover:from-orange-500 hover:to-orange-700 hover:shadow-2xl active:scale-95 animate-pulse-glow w-full"
              >
                <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
                <span className="relative z-10">Undo</span>
              </button>
            </div>
          </div>
        ) : (
          <button
            onClick={(e) =>
              dispatch(deleteClaim(claimantId, state.currentUserName))
            }
            className="relative px-5 py-2  tracking-wide text-white  rounded-lg bg-gradient-to-br from-red-400 to-red-600 shadow-lg transition duration-300 ease-in-out transform hover:scale-105 hover:from-red-500 hover:to-red-700 hover:shadow-2xl active:scale-95 animate-pulse-glow"
          >
            <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
            <span className="relative z-10">Delete</span>
          </button>
        )}
      </td>
      <td className="text-center">
        {assessmentStartFinalDate === 0
          ? "Today"
          : `${assessmentStartFinalDate} days`}
      </td>
    </tr>
  );
};
